import './gallery.js';
/*initializing aos animate with global settings*/

AOS.init({
    once: true
});


function classToggle() {
    const navs = document.querySelectorAll('.Navbar__Items')

    navs.forEach(nav => nav.classList.toggle('Navbar__ToggleShow'));
}

document.querySelector('.Navbar__Link-toggle').addEventListener('click', classToggle);


function tagtoggle() {


    //click
    $("button").click(function () {
        $(this)
            .parents(".grid_item")
            .toggleClass("active");
        $(this)
            .parents(".grid_item")
            .siblings(".grid_item")
            .removeClass("active");
    });



}

tagtoggle();

var accordions = document.getElementsByClassName("accordion");

for (var i = 0; i < accordions.length; i++) {
    accordions[i].onclick = function () {
        this.classList.toggle('is-open');

        var content = this.nextElementSibling;
        if (content.style.maxHeight) {
            // accordion is currently open, so close it
            content.style.maxHeight = null;
        } else {
            // accordion is currently closed, so open it
            content.style.maxHeight = content.scrollHeight + "px";
        }
    }
}

// Nav dropdown

let link = document.querySelector('.Navbar__Link.has_dropdown');
let noclicklink = link;
let clickFlag = false;
link.addEventListener('mouseenter', function(e) {
    document.querySelector('.dropdown').classList.add('show');
})
link.addEventListener('mouseleave', function(e) {
    document.querySelector('.dropdown').classList.remove('show');
})
noclicklink.addEventListener('click', function(e) {
    // If the user clicks 'information' the page reloads
    // Bad UX, so just don't do anything if they click on it
    e.preventDefault();
})

//let dropdownLinks = document.querySelectorAll('.dropdown .links a');
/* for (let i = 0 ; i < dropdownLinks.length ; i++) {
    dropdownLinks[i].addEventListener('click', function(e) {
        document.querySelector('.dropdown').classList.remove('show');
        // Scroll to position when dropdown link is clicked
        // Can't use hashing because the navbar blocks the top of the element and it looks bad, trust me
        let element = e.currentTarget.classList.value;
        let yPos = document.querySelector(`#${element}`).getBoundingClientRect().top - 100;
        window.scrollBy(0, yPos);
    })
} */



// Video play button

let video = document.querySelector('video');
let play = document.querySelector('.play');

if (play) {
    play.addEventListener('click', function() {
        video.play();
        play.classList.add('hidden');
        console.log(video.setAttribute('controls', true));
    })
}

// Vendor application form file submission detector

let logo = document.getElementById("logo");
let permit = document.getElementById("permit")

if (logo) {
    logo.addEventListener('change', function(){
        if(document.getElementById("logo").value != "") {
            let path = document.getElementById("logo").value;
            let path_string = path.split('\\');
            document.querySelector('.logofilename').textContent = path_string[path_string.length - 1];
        }
    })
    
    permit.addEventListener('change', function(){
        if(document.getElementById("permit").value != "") {
            let path = document.getElementById("permit").value;
            let path_string = path.split('\\');
            document.querySelector('.permitfilename').textContent = path_string[path_string.length - 1];
        }
    })
}

//(function ($) {
//    'use strict';
//    var $body = $('html, body'), // Define jQuery collection 
//        content = $('#main').smoothState({
//            onStart: {
//                duration: 250,
//                render: function () {
//                    content.toggleAnimationClass('is-exiting');
//
//                    // Scroll user to the top
//                    $body.animate({
//                        'scrollTop': 0
//                    });
//
//                }
//            }
//        }).data('smoothState');
//})(jQuery);
